import { FundBasketSummary } from "creso-core/types";
import { formatAsPercentage } from "creso-core/utils";

const SEGMENTS = [
  { key: "equity", label: "Equity", color: "var(--chart-1)" },
  { key: "debt", label: "Debt", color: "var(--chart-2)" },
  { key: "cash", label: "Cash", color: "var(--chart-3)" },
  { key: "others", label: "Others", color: "var(--chart-4)" },
] as const;

export function BasketAllocationLineChart({
  basket,
}: {
  basket: FundBasketSummary;
}) {
  const { asset_allocation } = basket;

  const total =
    (asset_allocation?.equity ?? 0) +
    (asset_allocation?.debt ?? 0) +
    (asset_allocation?.cash ?? 0) +
    (asset_allocation?.others ?? 0);

  if (total === 0) return null;

  const dominant = SEGMENTS.reduce((a, b) =>
    asset_allocation[a.key] >= asset_allocation[b.key] ? a : b
  );

  return (
    <div className="flex flex-col gap-2 w-full">
      <div className="flex items-center gap-1.5">
        <span className="text-xs text-foreground">
          {formatAsPercentage((asset_allocation[dominant.key] / total) * 100)}{" "}
          {dominant.label}
        </span>
      </div>
      <div className="flex h-1.5 w-full gap-0.5 rounded-xs overflow-hidden">
        {SEGMENTS.map(({ key, color }) => {
          const value = asset_allocation[key];
          if (value === 0) return null;
          return (
            <div
              key={key}
              className="rounded-xs"
              style={{
                width: `${(value / total) * 100}%`,
                backgroundColor: color,
              }}
            />
          );
        })}
      </div>
    </div>
  );
}
